var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJwtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1870.6 624.9",
    style: {
      enableBackground: "new 0 0 1870.6 624.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FCF497;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00F2E6;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00B9F1;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#D63AFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FB015B;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.8,168.1L358.2,0h-93.8l0.6,168.1l46.9,64.4L358.8,168.1z M265,456.2v168.7h93.8V456.2l-46.9-64.4 L265,456.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.8,456.2l98.8,136.3l75.6-55l-98.8-136.3l-75.6-24.4V456.2z M265,168.1L165.6,31.8L90,86.8L188.8,223 l76.2,24.4V168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,223.1l-160-51.9L0,259.9l160,52.5l75.6-25L188.8,223.1z M387.5,336.8l46.9,64.4l160,51.9l28.8-88.7 l-160-51.9L387.5,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M463.1,312.5l160-52.5l-28.8-88.7l-160,51.9l-46.9,64.4L463.1,312.5z M160,312.5L0,364.4l28.8,88.7l160-51.9 l46.9-64.4L160,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M188.8,401.2L90,537.5l75.6,55L265,456.2v-79.4L188.8,401.2z M434.4,223.1l98.8-136.3l-75.6-55L358.8,168v79.4 L434.4,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M973.1,159.3V378c0,48.1-39.4,87.5-87.5,87.5v-43.8c24.4,0,43.8-19.4,43.8-43.8V159.3H973.1z M1771.9,203.1 h98.7v-43.7H1630v43.7h98.1v262.5h43.8V203.1z M1498.1,159.3V378c0,24.4-19.4,43.8-43.8,43.8s-43.8-19.4-43.8-43.8V246.8 c0-48.1-39.4-87.5-87.5-87.5s-87.5,39.4-87.5,87.5v131.3c0,24.4-19.4,43.8-43.8,43.8s-43.8-19.4-43.8-43.8V159.3h-43.8V378 c0,48.1,39.4,87.5,87.5,87.5s87.5-39.4,87.5-87.5V246.8c0-24.4,19.4-43.8,43.8-43.8s43.8,19.4,43.8,43.8v131.3 c0,48.1,39.4,87.5,87.5,87.5s87.5-39.4,87.5-87.5V159.3H1498.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwtLogo);
export default __webpack_public_path__ + "static/media/jwt-logo.72f7d16134259b7f5ace393418d87cbe.svg";
export { ForwardRef as ReactComponent };